import React, { useState, useEffect } from "react";
import Button from "../../components/General/button.jsx";
import Input from "../../components/General/input.jsx";
import Select from "../../components/General/select.jsx";
import Searchbar from "../../components/General/searchbar.jsx";
import "./style/tutoringModal.css";
import { ConsoleSqlOutlined, LeftOutlined } from "@ant-design/icons";
import { createContext } from "react";
import { useContext } from "react";
import { useCallback } from "react";
import moment from "moment";

import { endpoints } from "../../utils/server.js";
import server from "../../utils/server.js";
import { message } from "antd";

const TutoringContext = createContext()

const TutoringContextProvider = ({ children })=>{
  // Cuando se pase al refactor se usara el contexto de Cycle
  // const { idCycle } =  useContext(CycleContext)

  const [typeOfAsesorado, setTypeOfAsesorado] = useState(1)
  const [asesorado, setAsesorado ] = useState("")
  const [idTutoredUser, setIdTutoreduser ] =  useState(null)
  const [email, setEmail] = useState("");
  const [tema, setTema] = useState("");
  const [equipo, setEquipo] = useState("");
  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [duracion, setDuracion] = useState(1);

  const resetVars = ()=>{
    setTypeOfAsesorado(1)
    setAsesorado("");
    setEmail("");
    setTema("");
    setEquipo("");
    setFecha("");
    setDuracion(1);
    setIdTutoreduser(null);
  }
  // Estos son endpoints que deberian pertenecer a otros contextos pero provicionalmente las coloco aqui.

  const GetAllUsersInCycleWithTeam = useCallback(async (idCycle)=> {
    
    try{
      const params = {
        id_cycle: idCycle
      };
      const res = await server(endpoints.getAllUsersInCycleWithTeams.route, endpoints.getAllUsersInCycleWithTeams.method, params);

      if(res.error_message) throw new Error(res.error_message);
      return res.data;
    
    } catch (error){

      message.error( error.message || String(error));
    
    }
  }, [])

  const GetTeamsInCycle = useCallback(async (idCycle)=> {
    try{
      const params = {
        id_cycle: idCycle
      };

      const res = await server(endpoints.getTeamsInCycle.route, endpoints.getTeamsInCycle.method, params);
      
      if(res.error_message) throw new Error(res.error_message);
      return res.data;
    
    } catch (error){
      message.error(error.message || String(error));
    }
  }, [])


  //----------------------------------------------------------------------------

  const DeleteTutoring = useCallback(async (idTutoring)=> {
    try{
      const params = {
        id_tutoring: idTutoring
      };
      const res = await server(endpoints.deleteTutoring.route, endpoints.deleteTutoring.method, params);
      
      const { error_message } = res;
      if (error_message) {
        message.error(error_message);
        return;
      } 
      
      message.success("Asesoria eliminada exitosamente");

    } catch (error){
      message.error(error);
    }
  }, [])

  const InsertTutoring = useCallback(async (idCycle)=> {
    try{

      if(!typeOfAsesorado || !tema || !equipo || !fecha || !duracion || (typeOfAsesorado == 2 && !asesorado && !email) || (typeOfAsesorado == 1 && !idTutoredUser)) throw new Error("Todos los campos son obligatorios");

      const params = {
        id_cycle: idCycle
      };

      const body = {
        internal_check : typeOfAsesorado == 1 ? true : false,
        id_tutored_user : idTutoredUser, // internos
        name : asesorado, // externos
        email : email,    // externos
        title : tema,
        id_team :Number(equipo),
        date : fecha + " 00:00:00",
        description : " ",
        duration : Number(duracion)
      }
      if(typeOfAsesorado == 2 ) delete body.id_tutored_user;
      else {delete body.name; delete body.email;} 

      const res = await server(endpoints.insertTutoring.route, endpoints.insertTutoring.method, params, body);
      
      if(res.error_message) throw new Error(res.error_message + " este error fue por parte de back.");
      message.success("Asesoria creada exitosamente");

    } catch (error){
      message.error(error.message || String(error) );
    }
  }, [asesorado, idTutoredUser, equipo, fecha, duracion, typeOfAsesorado, tema, email])
  
  const UpdateTutoring = useCallback(async (idCycle, idTutoring)=> {
    try{

      if(!typeOfAsesorado || !tema || !equipo || !fecha || !duracion || (typeOfAsesorado == 2 && !asesorado && !email) || (typeOfAsesorado == 1 && !idTutoredUser)) throw new Error("Todos los campos son obligatorios");

      const params = {
        id_cycle: idCycle,
        id_tutoring: idTutoring
      };

      const body = {
        id_tutored_user : idTutoredUser, // internos
        name : asesorado, // externos
        email : email,    // externos
        title : tema,
        id_team :Number(equipo),
        date : fecha + " 00:00:00",
        description : " ",
        amount : Number(duracion)
      }

      if(typeOfAsesorado == 2 ) delete body.id_tutored_user;
      else {delete body.name; delete body.email;} 

      const res = await server(endpoints.updateTutoring.route, endpoints.updateTutoring.method, params, body);
      
      if(res.error_message) throw new Error(res.error_message);
      message.success("Asesoria actualizada exitosamente");

    } catch (error){
      message.error(error.message || String(error) );
    }
  }, [asesorado, idTutoredUser, equipo, fecha, duracion, typeOfAsesorado, tema, email])

  const GetSingleTutoring = useCallback(async (idCycle, idTutoring, idUR)=> {
    try{
      const params = {
        id_cycle: idCycle,
        id_tutoring: idTutoring,
        id_user: idUR
      };

      const res = await server(endpoints.getSingleTutoring.route, endpoints.getSingleTutoring.method, params);

      if(res.error_message) throw new Error(res.error_message);
      const tutoring  = res.data.singleTutoring[0];

      setTypeOfAsesorado( tutoring.id_tutored_user !== null ? 1 : 2);
      setAsesorado( tutoring.id_tutored_user === null ? tutoring.tutored_name : "");
      setIdTutoreduser(tutoring.id_tutored_user);
      setEmail( tutoring.id_tutored_user === null  ? tutoring.email : null);
      setTema(tutoring.tutoring_title);
      setEquipo(tutoring.team);
      setFecha(tutoring.date.split("T")[0]);
      setDuracion(tutoring.amount);
      
    } catch(error){
      message.error(error.message || String(error) );
    }
  }, []);

  return (
    <TutoringContext.Provider
      value={{
        typeOfAsesorado,
        setTypeOfAsesorado,
        asesorado,
        setAsesorado,
        idTutoredUser,
        setIdTutoreduser,
        email,
        setEmail,
        tema,
        setTema,
        equipo,
        setEquipo,
        fecha,
        setFecha,
        duracion,
        setDuracion,
        resetVars,
        DeleteTutoring,
        InsertTutoring,
        GetAllUsersInCycleWithTeam,
        GetTeamsInCycle,
        UpdateTutoring,
        GetSingleTutoring
      }}>
      { children }
    </TutoringContext.Provider>
  )

}

const TutoringModal = ({ idCycle, id_UR, session, onClose, updating, idTutoring }) => {
  const { typeOfAsesorado, setTypeOfAsesorado, setIdTutoreduser, idTutoredUser, asesorado, setAsesorado, email, setEmail, tema, setTema, equipo, setEquipo, fecha, setFecha, duracion, setDuracion, resetVars, DeleteTutoring, GetTutoringPerCycle, InsertTutoring, GetAllUsersInCycleWithTeam, GetTeamsInCycle, UpdateTutoring, GetSingleTutoring } = useContext(TutoringContext);

  const [isClosing, setIsClosing] = useState(false);
  const [membersArray, setMembersArray] = useState([]);
  const [teamsArray, setTeamsArray] = useState([]);

  useEffect(()=>{
    if(updating) GetSingleTutoring(idCycle, idTutoring, id_UR);
    
    GetAllUsersInCycleWithTeam(idCycle).then((res)=>{setMembersArray(res.map((option)=>({first_name : option.first_name,  last_name : option.last_name,  email : option.email, id : option.id})))});
    GetTeamsInCycle(idCycle).then((res)=>{setTeamsArray(res.map((option)=>({name : option.name, value : option.id})))});
  },[])

  useEffect(()=>{
    if (updating && membersArray.length > 0 && teamsArray.length > 0) {
       if (idTutoredUser != null){
        const member_f  = membersArray.filter((member)=> idTutoredUser == member.id)[0]
        setAsesorado(member_f.last_name + " " + member_f.first_name)
      }

      const team_f  = teamsArray.filter((team)=> equipo == team.name)[0]
      setEquipo(team_f?.value)
    }

  },[membersArray, teamsArray])

  const closeModal = () => {
    resetVars();
    setIsClosing(true);
    setTimeout(() => onClose(), 500);
  };

  const handleSubmit=()=>{
     if (typeOfAsesorado == 1) { setAsesorado("")}
     else if (typeOfAsesorado == 2) setIdTutoreduser(null)

    InsertTutoring(idCycle);
    closeModal();
  }
  
  const handleAsesoradoChange=(value)=>{
    setAsesorado(value)
    setIdTutoreduser(membersArray.filter((member)=> value == member.last_name + " " + member.first_name)[0]?.id)
  }

  const Icon  = ()=>{
    return(<LeftOutlined/>)
  }

  return (
    <div className={`tutoring__modal__background ${isClosing ? "closing" : ""}`} onClick={closeModal}>
      <div className={`tutoring__modal__content__container ${ isClosing ? "closing" : "" }`} onClick={(e) => e.stopPropagation()}>
        
        <Button text={"Cerrar"} onClickAction={closeModal}  type={"default secondary"} icon={<Icon/>}/>

        <div className="tutoring__modal__content__header__container">
          <img className="tutoring__modal__content__header__profileImage" src={session.profile_photo_url} alt=""/>
          <div className="tutoring__modal__content__header__text__container">
            <h1 className="tutoring__modal__content__header__text__title">{!updating ? "Nueva asesoria" : "Actualizar asesoria"}</h1>
            <p className="tutoring__modal__content__header__text__name">{session ? session.full_name : "Un texto para mostrar"}</p>
          </div>
        </div>

        <div className="tutoring__modal__content__body__container" style={{width:"100%", display:"flex", flexDirection:"column", justifyContent:"left", gap:"15px"}}>
          
          { updating &&
            <h1 style={{fontSize:"18px", display:"flex", flexDirection :"row", alignItems:"center", justifyContent:"space-around", alignContent:"space-around", gap:"10px"}}> <span> Asesor </span> : <span>{session.full_name}</span></h1>
          }
          
          { !updating &&
          <Select placeholder={"Asesorado"} 
                  optionsArray={[{name : "Interno", value : 1}, {name : "Externo", value : 2}]} 
                  value={typeOfAsesorado} 
                  setValue={setTypeOfAsesorado}
                  required={true}
          />
          }

          {typeOfAsesorado == 2 ? 
          <>
            <Input placeholder={"Nombre  del asesorado"} required={true} value={asesorado} setValue={setAsesorado}/>

            <Input placeholder={"Email del Asesorado"} required={true} value={email} setValue={setEmail}/>
          </> 
          :
            <div style={{width:"100%", maxWidth:"275px"}}>
              <span style={{fontSize:"16px"}}>Asesorado:</span>
              <Searchbar value={asesorado} setValue={handleAsesoradoChange} suggestions={membersArray.map((option)=>(option.last_name + " " + option.first_name))}/>
            </div>
          }


          <Select placeholder={"Equipo"} required={true} value={equipo} setValue={setEquipo} optionsArray={teamsArray} />


          <Input placeholder={"Tema de la asesoria"} 
                  value={tema} 
                  setValue={setTema}
          />

          <Input placeholder={"Fecha"} required={true} type={"date"} value={fecha} setValue={setFecha}/>
          <Select placeholder={"Duración"} required={true} value={duracion} setValue={setDuracion}
                  optionsArray={[{name : "15 minutos", value : 1}, {name : "30 minutos", value : 2}, {name : "45 minutos", value : 3}, {name : "60 minutos", value : 4}, {name : "75 minutos", value : 5}, {name : "90 minutos", value : 6}]} />


          {
            !updating ?
              <Button text={"Crear"} onClickAction={handleSubmit} type={"default primary"}/>
            :
            <>
              <Button text={"Actualizar"} onClickAction={()=>{UpdateTutoring(idCycle, idTutoring); closeModal()}} type={"default primary"}/>
              <Button text={"Eliminar"} onClickAction={()=>{DeleteTutoring(idTutoring); closeModal()}} type={"destructive secondary"}/>
            </>
          }
        </div>

      </div>
    </div>
  );
};

const TutoringModalWrapper = ({ idCycle, id_UR, session, onClose, updating, infoTutoring })=>{
  var idTutoring = null;
  if(updating){
    idTutoring = infoTutoring.id;
  }

  return(
    <TutoringContextProvider>
      <TutoringModal idCycle={idCycle} id_UR={id_UR} session={session} onClose={onClose} updating={updating} idTutoring={idTutoring}/>
    </TutoringContextProvider>
  )
}

export default TutoringModalWrapper;
